/**
 * Performance Optimizer - lazy-loading helper (rewritten 21 Sep 2026)
 *
 * Previous version re-scanned every <img> on the page and called
 * getBoundingClientRect() on each one whenever ANY node was added to the DOM,
 * forcing repeated synchronous layout for the life of the page.
 *
 * This version:
 *  - runs one pass after the DOM is ready, reading all positions first and
 *    writing attributes afterwards (no layout thrash);
 *  - never touches images that are already visible or that the theme/apps
 *    already gave a loading attribute;
 *  - for content added later, only looks at the added nodes, with no layout reads.
 */
(function () {
  'use strict';

  function lazyIframes(root) {
    var frames = root.querySelectorAll ? root.querySelectorAll('iframe:not([loading])') : [];
    for (var i = 0; i < frames.length; i++) frames[i].setAttribute('loading', 'lazy');
  }

  function initialPass() {
    var imgs = document.querySelectorAll('img:not([loading])');
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    var offscreen = [];

    // Read phase: measure everything once.
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      var visible = r.bottom > 0 && r.top < viewportH;
      if (!visible) offscreen.push(imgs[i]);
    }

    // Write phase: only images below the fold get lazy-loaded.
    for (var j = 0; j < offscreen.length; j++) {
      offscreen[j].setAttribute('loading', 'lazy');
      if (!offscreen[j].hasAttribute('decoding')) offscreen[j].setAttribute('decoding', 'async');
    }

    lazyIframes(document);
  }

  function handleAdded(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'IMG') {
      if (!node.hasAttribute('loading')) node.setAttribute('loading', 'lazy');
      if (!node.hasAttribute('decoding')) node.setAttribute('decoding', 'async');
      return;
    }
    if (node.tagName === 'IFRAME') {
      if (!node.hasAttribute('loading')) node.setAttribute('loading', 'lazy');
      return;
    }
    if (!node.querySelectorAll) return;
    var imgs = node.querySelectorAll('img:not([loading])');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('loading', 'lazy');
      if (!imgs[i].hasAttribute('decoding')) imgs[i].setAttribute('decoding', 'async');
    }
    lazyIframes(node);
  }

  function start() {
    initialPass();
    if (!window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) handleAdded(added[j]);
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
